import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-secondary-900 text-background-50">
      <section className="py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold mb-4 text-background-50">
            {t("cta.title")}
          </h2>
          <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
            {t("cta.subtitle")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("cta.button")}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>
      </section>

      <div className="border-t border-background-50/10">
        <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              <Link
                to="/"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.home")}
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.article")}
              </Link>
              <Link
                to="/artykul/kakobuy-buty-poradnik"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.articleButy")}
              </Link>
              <Link
                to="/artykul/kakobuy-bezpieczenstwo"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.articleBezpieczenstwo")}
              </Link>
              <Link
                to="/artykul/kakobuy-wysylka-polska"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.articleWysylka")}
              </Link>
              <Link
                to="/artykul/kakobuy-dla-poczatkujacych"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.articlePoczatkujacy")}
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t("footer.categories")}
              </a>
            </div>
            <p className="text-xs text-background-50/50">
              {t("footer.copyright")}
            </p>
          </div>
          <p className="text-xs text-background-50/40 mt-4 text-center md:text-left">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}